
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Lupus_nephritis",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Lupus_nephritis.vue